import { atom } from "jotai";
import type { Socket } from "socket.io-client";

export type SocketMap = {
  charting: Socket;
  chat: Socket;
  distribution: Socket;
  "universal-clinic-chat": Socket;
};

export const socketsAtom = atom<SocketMap | null>(null);
